import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DefaultErrorHandler } from './core/default-error-handler.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TOKEN_SERVICE_STORAGE } from './core/token-storage.service';
import { LOCAL_STORAGE, SESSION_STORAGE } from 'ngx-webstorage-service';
import { USER_INFO_STORAGE } from './core/user-info-storage.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { Settings } from 'luxon';
import { CoreModule } from './core/core.module';
import { ErrorComponent } from './error/error.component';
import { GoogleAuthorizationComponent } from './google-authorization/google-authorization.component';
import { SharedModule } from './main/shared/shared.module';
import { ViewerNotActiveComponent } from './viewer-not-active/viewer-not-active.component';
import { NgMaterialModule } from './core/ng-material/ng-material.module';
import {StepService} from './main/bookings/create-booking/step.service';
import { KnowledgeBaseNotAuthorizedComponent } from './knowledge-base-not-authorized/knowledge-base-not-authorized.component';
import { SocketMessagesService } from './core/socket/socket.service';
// import { EditorModule } from '@tinymce/tinymce-angular';
import { QuillModule } from 'ngx-quill';
import * as Sentry from "@sentry/angular";
import { Router } from '@angular/router';
Settings.defaultZone = 'UTC';

@NgModule({ declarations: [
        AppComponent,
        ErrorComponent,
        GoogleAuthorizationComponent,
        ViewerNotActiveComponent,
        KnowledgeBaseNotAuthorizedComponent,
    ],
    bootstrap: [AppComponent],
    imports: [
        // EditorModule,
        NgMaterialModule,
        CoreModule, // + SharedModule
        BrowserModule,
        NgSelectModule,
        AppRoutingModule,
        BrowserAnimationsModule, // required animations module
        AngularSvgIconModule.forRoot(),
        SharedModule,
        QuillModule.forRoot() // Make sure this is here
    ],
    providers: [
        { provide: ErrorHandler, useClass: DefaultErrorHandler },
        // {
        //     provide: ErrorHandler,
        //     useValue: Sentry.createErrorHandler({
        //       showDialog: true,
        //     }),
        // },
        {
            provide: Sentry.TraceService,
            deps: [Router],
        },
        { provide: TOKEN_SERVICE_STORAGE, useExisting: LOCAL_STORAGE },
        { provide: USER_INFO_STORAGE, useExisting: SESSION_STORAGE },
        StepService,
        SocketMessagesService,
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {
    constructor(trace: Sentry.TraceService) {}
}
